import React from 'react';
import { Link } from 'react-router-dom';

const orgLinkFormatter = (cell, row) => {
  return <Link to={`/ddrr/${row.id}`}>{cell}</Link>;
};

export default orgLinkFormatter;
